var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGivings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26123 17.507L5.45049 20.998C6.06666 21.5114 6.84333 21.7927 7.64539 21.7927H18.6899C19.4788 21.7927 20.1184 21.1531 20.1184 20.364C20.1184 18.7862 18.8392 17.507 17.2612 17.507H9.58288",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40408 15.7926L7.6898 17.0783C8.39989 17.7885 9.55115 17.7885 10.2612 17.0783C10.9713 16.3683 10.9713 15.217 10.2612 14.5069L8.26543 12.5111C7.62246 11.8682 6.75038 11.5069 5.84108 11.5069H1.26123",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3081 8.09417C11.7065 7.9895 11.7065 7.12589 12.3081 7.02123C14.4876 6.64205 16.2211 4.982 16.6941 2.82097L16.7304 2.65532C16.8606 2.06074 17.7071 2.05705 17.8426 2.65045L17.8864 2.8435C18.3771 4.99435 20.1111 6.64037 22.2844 7.01849C22.8891 7.12368 22.8891 7.99171 22.2844 8.09689C20.1111 8.47501 18.3771 10.121 17.8864 12.2719L17.8426 12.4649C17.7071 13.0583 16.8606 13.0546 16.7304 12.4601L16.6941 12.2944C16.2211 10.1334 14.4876 8.47334 12.3081 8.09417Z",
    stroke: "#979592",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGivings);
export default __webpack_public_path__ + "static/media/givings.92ee3e4cc66ada87ea6a271ddc9237df.svg";
export { ForwardRef as ReactComponent };